import { format } from "date-fns";
import { fr } from "date-fns/locale";

export default function EventFilling({
  totalSoldTickets,
  maxCapacity,
  costingCapacity,
  numberOfGauges = 20,
  eventTicketsSyncedAt,
}: {
  totalSoldTickets: number;
  maxCapacity: number;
  costingCapacity: number;
  numberOfGauges?: number;
  eventTicketsSyncedAt?: Date;
}) {
  const capacity = maxCapacity || costingCapacity;
  const fillingPercentage = (totalSoldTickets / capacity) * 100;
  const gaugeFillPercentage = Math.floor(
    fillingPercentage / (100 / numberOfGauges)
  );

  let fillColor = "";
  if (fillingPercentage <= 25) {
    fillColor = "#E14545"; // Red
  } else if (fillingPercentage <= 60) {
    fillColor = "#E1B957"; // Yellow
  } else {
    fillColor = "#37C168"; // Green
  }

  const gauge = Array.from({ length: numberOfGauges }, (_, i) => {
    return (
      <div
        key={i}
        style={{
          backgroundColor: `${i < gaugeFillPercentage ? fillColor : "#676974"}`,
        }}
        className="w-full h-6 rounded-sm"
      ></div>
    );
  });

  return (
    <div className="h-30 text-center text-secondary flex flex-col justify-center">
      {eventTicketsSyncedAt ? (
        <div className="text-xs text-secondary mb-2 text-right">
          Dernière synchronisation :{" "}
          {format(eventTicketsSyncedAt, "dd/MM/yyyy HH:mm", { locale: fr })}
        </div>
      ) : null}
      <div className="flex gap-0.5">{gauge}</div>
      <div className="flex gap-2">
        <div className="text-xs font-thin text-secondary mt-2">
          {totalSoldTickets}/{capacity} places
        </div>
      </div>

      <div className="flex justify-around mt-4 items-center">
        <div className="flex flex-col">
          <div className="text-xl font-medium text-primary">
            {fillingPercentage.toFixed(0)}%
          </div>
          <div className="text-xs text-secondary">remplissage</div>
        </div>

        <div className="flex flex-col">
          <div className="text-primary">
            <span className="text-2xl">{totalSoldTickets}</span>{" "}
            <span className="text-sm">/{capacity}</span>
          </div>
          <div className="text-xs text-secondary">volume</div>
        </div>
      </div>
    </div>
  );
}
